const STATUS_REFRESH_TIMER_IN_MS = 30000;
export default STATUS_REFRESH_TIMER_IN_MS;
